var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBishopWhite2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 31.5C7.39 30.53 14.11 31.93 17.5 29.5C20.89 31.93 27.61 30.53 31 31.5C31 31.5 32.65 32.04 34 33.5C33.32 34.47 32.35 34.49 31 34C27.61 33.03 20.89 34.46 17.5 33C14.11 34.46 7.39 33.03 4 34C2.65 34.49 1.68 34.47 1 33.5C2.35 32.04 4 31.5 4 31.5Z",
    fill: "white",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 27.5C12.5 30 22.5 30 25 27.5C25.5 26 25 25.5 25 25.5C25 23 22.5 21.5 22.5 21.5C28 20 28.5 10 17.5 6C6.50002 10 7.00002 20 12.5 21.5C12.5 21.5 10 23 10 25.5C10 25.5 9.50002 26 10 27.5Z",
    fill: "white",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.5C20 4.16304 19.7366 4.79893 19.2678 5.26777C18.7989 5.73661 18.163 6 17.5 6C16.837 6 16.2011 5.73661 15.7322 5.26777C15.2634 4.79893 15 4.16304 15 3.5C15 2.83696 15.2634 2.20107 15.7322 1.73223C16.2011 1.26339 16.837 1 17.5 1C18.163 1 18.7989 1.26339 19.2678 1.73223C19.7366 2.20107 20 2.83696 20 3.5Z",
    fill: "white",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.5H22.5M10 25.5H25M17.5 11V16M15 13.5H20",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 31.5C24.39 30.53 31.11 31.93 34.5 29.5C37.89 31.93 44.61 30.53 48 31.5C48 31.5 49.65 32.04 51 33.5C50.32 34.47 49.35 34.49 48 34C44.61 33.03 37.89 34.46 34.5 33C31.11 34.46 24.39 33.03 21 34C19.65 34.49 18.68 34.47 18 33.5C19.35 32.04 21 31.5 21 31.5Z",
    fill: "white",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 27.5C29.5 30 39.5 30 42 27.5C42.5 26 42 25.5 42 25.5C42 23 39.5 21.5 39.5 21.5C45 20 45.5 10 34.5 6C23.5 10 24 20 29.5 21.5C29.5 21.5 27 23 27 25.5C27 25.5 26.5 26 27 27.5Z",
    fill: "white",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 3.5C37 4.16304 36.7366 4.79893 36.2678 5.26777C35.7989 5.73661 35.163 6 34.5 6C33.837 6 33.2011 5.73661 32.7322 5.26777C32.2634 4.79893 32 4.16304 32 3.5C32 2.83696 32.2634 2.20107 32.7322 1.73223C33.2011 1.26339 33.837 1 34.5 1C35.163 1 35.7989 1.26339 36.2678 1.73223C36.7366 2.20107 37 2.83696 37 3.5Z",
    fill: "white",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 21.5H39.5M27 25.5H42M34.5 11V16M32 13.5H37",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBishopWhite2);
export default __webpack_public_path__ + "static/media/Bishop White 2.62810eeac5d3569adfda6f222fd6f709.svg";
export { ForwardRef as ReactComponent };